import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const HesapMakinesiKutusu = ({ sube, forceOpen, onClose }) => {
  const [open, setOpen] = useState(forceOpen || false);
  const [display, setDisplay] = useState("");
  const [history, setHistory] = useState("");

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose(); 
  };

  const handleClick = (value) => {
    if (value === "C") {
      setDisplay("");
      setHistory("");
    } else if (value === "DEL") {
      setDisplay((prev) => prev.slice(0, -1));
    } else if (value === "=") {
      try {
        if (!display) return;
        const result = eval(display.replace(/,/g, '.')); 
        setHistory(display + " =");
        setDisplay(Number(result).toFixed(3).replace('.', ',')); 
      } catch (error) {
        setDisplay("Hata");
      }
    } else {
      setDisplay((prev) => prev + value);
    }
  };

  const handleMilyem = (carpan, label) => {
    try {
      const currentVal = parseFloat(display.replace(/,/g, '.') || 0);
      if (currentVal > 0) {
        const result = currentVal * carpan;
        // 0.320 gibi son sıfırları korumak için toFixed(3) kullanıyoruz
        setHistory(`${display} x ${label} (${carpan.toFixed(3)})`);
        setDisplay(result.toFixed(3).replace('.', ',')); 
      }
    } catch (e) {
      setDisplay("Hata");
    }
  };

  // --- KLAVYE KONTROLÜ ---
  useEffect(() => {
    if (!open) return; 

    const handleKeyDown = (e) => {
      const key = e.key;

      if (/[0-9]/.test(key)) {
        handleClick(key);
      }
      else if (['+', '-', '*', '/'].includes(key)) {
        handleClick(key);
      }
      else if (key === 'Enter') {
        e.preventDefault(); 
        document.getElementById('btn-equal')?.click();
      }
      else if (key === 'Backspace') {
        handleClick('DEL');
      }
      else if (key === 'Delete' || key.toLowerCase() === 'c') {
        handleClick('C');
      }
      else if (key === 'Escape') {
        handleClose();
      }
      else if (key === '.' || key === ',') {
        handleClick(',');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, display]); 

  // --- STİL AYARLARI ---
  const btnBaseStyle = {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    height: '60px',
    borderRadius: '8px',
    width: '100%', 
    boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
    textTransform: 'none',
    fontFamily: "'Roboto', sans-serif",
    minWidth: 'unset'
  };

  const karatStyle = { ...btnBaseStyle, bgcolor: '#ff9800', color: 'white', fontSize: '1rem', '&:hover': { bgcolor: '#f57c00' } };
  const numStyle = { ...btnBaseStyle, bgcolor: '#f5f5f5', color: '#333', border: '1px solid #ddd', '&:hover': { bgcolor: '#eeeeee' } };
  const opStyle = { ...btnBaseStyle, bgcolor: '#1976d2', color: 'white', fontSize: '1.6rem', '&:hover': { bgcolor: '#1565c0' } };
  const clearStyle = { ...btnBaseStyle, bgcolor: '#d32f2f', color: 'white', '&:hover': { bgcolor: '#c62828' } };
  const equalStyle = { ...btnBaseStyle, bgcolor: '#2e7d32', color: 'white', fontSize: '1.6rem', '&:hover': { bgcolor: '#1b5e20' } };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      PaperProps={{ sx: { width: '380px', maxWidth: '100%', borderRadius: 3, m: 2 } }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
        {/* BAŞLIK DEĞİŞTİRİLDİ */}
        <Typography variant="h6" fontWeight="bold" color="#333">Hurda Hızlı Hesap</Typography>
        <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ p: 2, bgcolor: '#fff' }}>
        
        {/* EKRAN */}
        <Box sx={{ 
          bgcolor: '#222', color: '#fff', p: 2, borderRadius: 2, mb: 2, 
          textAlign: 'right', height: '85px', display: 'flex', flexDirection: 'column', justifyContent: 'center',
          width: '100%', 
          boxSizing: 'border-box'
        }}>
          <Typography variant="caption" sx={{ color: '#aaa' }}>{history}</Typography>
          <Typography variant="h4" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>{display || "0"}</Typography>
        </Box>

        {/* TUŞ TAKIMI - CSS GRID (KESİN HİZALAMA) */}
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(4, 1fr)', 
          gap: 1.2, 
          width: '100%' 
        }}>
          
          {/* 1. SATIR */}
          <Button sx={karatStyle} onClick={() => handleMilyem(0.995, '24K')}>24K</Button>
          <Button sx={karatStyle} onClick={() => handleMilyem(0.912, '22K')}>22K</Button>
          <Button sx={karatStyle} onClick={() => handleMilyem(0.865, '21K')}>21K</Button>
          <Button sx={karatStyle} onClick={() => handleMilyem(0.735, '18K')}>18K</Button>

          {/* 2. SATIR */}
          <Button sx={karatStyle} onClick={() => handleMilyem(0.575, '14K')}>14K</Button>
          <Button sx={karatStyle} onClick={() => handleMilyem(0.370, '10K')}>10K</Button>
          <Button sx={karatStyle} onClick={() => handleMilyem(0.320, '8K')}>8K</Button>
          <Button sx={clearStyle} onClick={() => handleClick("C")}>C</Button>

          {/* 3. SATIR */}
          <Button sx={numStyle} onClick={() => handleClick("9")}>9</Button>
          <Button sx={numStyle} onClick={() => handleClick("8")}>8</Button>
          <Button sx={numStyle} onClick={() => handleClick("7")}>7</Button>
          <Button sx={opStyle} onClick={() => handleClick("/")}>÷</Button>

          {/* 4. SATIR */}
          <Button sx={numStyle} onClick={() => handleClick("6")}>6</Button>
          <Button sx={numStyle} onClick={() => handleClick("5")}>5</Button>
          <Button sx={numStyle} onClick={() => handleClick("4")}>4</Button>
          <Button sx={opStyle} onClick={() => handleClick("*")}>×</Button>

          {/* 5. SATIR */}
          <Button sx={numStyle} onClick={() => handleClick("3")}>3</Button>
          <Button sx={numStyle} onClick={() => handleClick("2")}>2</Button>
          <Button sx={numStyle} onClick={() => handleClick("1")}>1</Button>
          <Button sx={opStyle} onClick={() => handleClick("-")}>-</Button>

          {/* 6. SATIR */}
          <Button sx={numStyle} onClick={() => handleClick("0")}>0</Button>
          <Button sx={numStyle} onClick={() => handleClick(",")}>,</Button>
          <Button id="btn-equal" sx={equalStyle} onClick={() => handleClick("=")}>=</Button>
          <Button sx={opStyle} onClick={() => handleClick("+")}>+</Button>

        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default HesapMakinesiKutusu;